import { Component } from '@angular/core';

@Component({
  selector: 'vpfa-mobile-divider',
  templateUrl: './mobile-divider.component.html',
  styleUrls: ['./mobile-divider.component.scss'],
})
export class MobileDividerComponent {}
